import { endpointConstants } from "../constants";
import { get } from "../../utils";

export const yodaMessagesService = {
  getMessages,
};

function getMessages(customerId) {
  let endpoint = endpointConstants.YODACUSTOMER.GET_MESSAGES.replace(
    ":id",
    customerId,
  );
  return get(endpoint, {});
}
